import { Dispatch, AnyAction } from 'redux';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import {
  CREATE_SERVICIO_CLINICO_REQUEST,
  CREATE_SERVICIO_CLINICO_SUCCESS,
  CREATE_SERVICIO_CLINICO_FAILURE,
  FETCH_SERVICIOS_CLINICOS_REQUEST,
  FETCH_SERVICIOS_CLINICOS_SUCCESS,
  FETCH_SERVICIOS_CLINICOS_FAILURE,
  SET_SERVICIOS_CLINICOS_PAGE,
  SET_SERVICIOS_CLINICOS_LIMIT,
  UPDATE_SERVICIO_CLINICO_REQUEST,
  UPDATE_SERVICIO_CLINICO_SUCCESS,
  UPDATE_SERVICIO_CLINICO_FAILURE,
  DELETE_SERVICIO_CLINICO_REQUEST,
  DELETE_SERVICIO_CLINICO_SUCCESS,
  DELETE_SERVICIO_CLINICO_FAILURE
} from '../../../constants/servicios_clinicos/Servicios_clinicos';
import { message } from 'antd';
import { RootState } from '../../store/store';
import fetchWithIP from '../../../redux/actions/utils/FechHeaders';

export const createServicioClinicoRequest = () => ({
  type: CREATE_SERVICIO_CLINICO_REQUEST
});

export const createServicioClinicoSuccess = (data: any) => ({
  type: CREATE_SERVICIO_CLINICO_SUCCESS,
  payload: data
});

export const createServicioClinicoFailure = (error: string) => ({
  type: CREATE_SERVICIO_CLINICO_FAILURE,
  payload: error
});

export const fetchServiciosClinicosRequest = () => ({
  type: FETCH_SERVICIOS_CLINICOS_REQUEST
});

export const fetchServiciosClinicosSuccess = (data: any) => ({
  type: FETCH_SERVICIOS_CLINICOS_SUCCESS,
  payload: data
});

export const fetchServiciosClinicosFailure = (error: string) => ({
  type: FETCH_SERVICIOS_CLINICOS_FAILURE,
  payload: error
});

export const setServiciosClinicosPage = (page: number) => ({
  type: SET_SERVICIOS_CLINICOS_PAGE,
  payload: page
});

export const setServiciosClinicosLimit = (limit: number) => ({
  type: SET_SERVICIOS_CLINICOS_LIMIT,
  payload: limit
});

export const updateServicioClinicoRequest = () => ({
  type: UPDATE_SERVICIO_CLINICO_REQUEST
});

export const updateServicioClinicoSuccess = (data: any) => ({
  type: UPDATE_SERVICIO_CLINICO_SUCCESS,
  payload: data
});

export const updateServicioClinicoFailure = (error: string) => ({
  type: UPDATE_SERVICIO_CLINICO_FAILURE,
  payload: error
});

export const deleteServicioClinicoRequest = () => ({
  type: DELETE_SERVICIO_CLINICO_REQUEST
});

export const deleteServicioClinicoSuccess = (servicioId: string) => ({
  type: DELETE_SERVICIO_CLINICO_SUCCESS,
  payload: servicioId
});

export const deleteServicioClinicoFailure = (error: string) => ({
  type: DELETE_SERVICIO_CLINICO_FAILURE,
  payload: error
});

export const createServicioClinico = (
  servicioData: any
): ThunkAction<Promise<any>, RootState, unknown, AnyAction> => {
  return async (dispatch: ThunkDispatch<RootState, unknown, AnyAction>) => {
    dispatch(createServicioClinicoRequest());

    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('No se encontró token de autenticación');
      }

      const response = await fetchWithIP(
        'servicios-clinicos',
        {
          method: 'POST',
        },
        servicioData
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Error al crear el servicio clínico');
      }

      dispatch(createServicioClinicoSuccess(data));
      message.success('Servicio clínico creado exitosamente');
      return data;
    } catch (error: any) {
      const errorMsg = error.message || 'Error desconocido al crear el servicio clínico';
      dispatch(createServicioClinicoFailure(errorMsg));
      message.error(errorMsg);
      throw error;
    }
  };
};

export const fetchServiciosClinicos = (
  page: number = 1,
  limit: number = 10,
  search?: string
): ThunkAction<Promise<any>, RootState, unknown, AnyAction> => {
  return async (dispatch: ThunkDispatch<RootState, unknown, AnyAction>) => {
    dispatch(fetchServiciosClinicosRequest());

    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('No se encontró token de autenticación');
      }

      let endpoint = `servicios-clinicos?page=${page}&limit=${limit}`;
      if (search) {
        endpoint += `&search=${encodeURIComponent(search)}`;
      }

      const response = await fetchWithIP(endpoint, { method: 'GET' });
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Error al obtener los servicios clínicos');
      }

      dispatch(fetchServiciosClinicosSuccess(data));
      return data;
    } catch (error: any) {
      const errorMsg = error.message || 'Error desconocido al obtener los servicios clínicos';
      dispatch(fetchServiciosClinicosFailure(errorMsg));
      message.error(errorMsg);
      throw error;
    }
  };
};

export const updateServicioClinico = (
  id: string,
  servicioData: any
): ThunkAction<Promise<any>, RootState, unknown, AnyAction> => {
  return async (dispatch: ThunkDispatch<RootState, unknown, AnyAction>) => {
    dispatch(updateServicioClinicoRequest());

    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('No se encontró token de autenticación');
      }

      const response = await fetchWithIP(
        `servicios-clinicos/${id}`,
        {
          method: 'PUT',
        },
        servicioData
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Error al actualizar el servicio clínico');
      }

      dispatch(updateServicioClinicoSuccess(data));
      message.success('Servicio clínico actualizado exitosamente');
      return data;
    } catch (error: any) {
      const errorMsg = error.message || 'Error desconocido al actualizar el servicio clínico';
      dispatch(updateServicioClinicoFailure(errorMsg));
      message.error(errorMsg);
      throw error;
    }
  };
};

export const deleteServicioClinico = (
  id: string
): ThunkAction<Promise<any>, RootState, unknown, AnyAction> => {
  return async (dispatch: ThunkDispatch<RootState, unknown, AnyAction>) => {
    dispatch(deleteServicioClinicoRequest());

    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('No se encontró token de autenticación');
      }

      const response = await fetchWithIP(`servicios-clinicos/${id}`, { method: 'DELETE' });
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Error al eliminar el servicio clínico');
      }

      dispatch(deleteServicioClinicoSuccess(id));
      message.success('Servicio clínico eliminado exitosamente');
      return data;
    } catch (error: any) {
      const errorMsg = error.message || 'Error desconocido al eliminar el servicio clínico';
      dispatch(deleteServicioClinicoFailure(errorMsg));
      message.error(errorMsg);
      throw error;
    }
  };
};